// Global front-end bundle, loaded on every page. Feature-specific code lives in
// delivery-timer-index.js and checkout-fields-index.js so it only loads where used.
import $ from 'jquery';

// Other theme scripts and inline snippets rely on a global $.
window.jQuery = $;
window.$ = $;

require('./js/sticky_cta.js');
require('./js/cart_count.js');
require('./js/mtc_checkout.js');
require('./js/script.js');
